import { render, staticRenderFns } from "./FetchProduct.vue?vue&type=template&id=d7be2a70&scoped=true&"
import script from "./FetchProduct.vue?vue&type=script&lang=js&"
export * from "./FetchProduct.vue?vue&type=script&lang=js&"
import style0 from "./FetchProduct.vue?vue&type=style&index=0&id=d7be2a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7be2a70",
  null
  
)

component.options.__file = "FetchProduct.vue"
export default component.exports